var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getFixSize } from '../../utils';
var IMAGE_SIZE = {};
var getImageSize = function (src) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (IMAGE_SIZE[src])
            return [2 /*return*/, IMAGE_SIZE[src]];
        IMAGE_SIZE[src] = new Promise(function (resolve) {
            var img = new window.Image();
            img.src = src;
            img.onload = function (e) {
                IMAGE_SIZE[src] = {
                    naturalWidth: img.naturalWidth,
                    naturalHeight: img.naturalHeight,
                    ratio: img.naturalWidth / img.naturalHeight,
                };
                resolve(IMAGE_SIZE[src]);
            };
            // sometimes it fails when blocking
            img.onerror = function () {
                delete IMAGE_SIZE[src];
                resolve({ naturalWidth: 0, naturalHeight: 0, ratio: 0 });
            };
        });
        return [2 /*return*/, IMAGE_SIZE[src]];
    });
}); };
var getImageFileList = function (files) {
    return Array.prototype.slice.call(files || '').filter(function (file) { return file.type.includes('image'); });
};
// get the image file selected by the input
var getInputImageFiles = function (event) {
    if (!event.target.files)
        return [];
    return getImageFileList(event.target.files);
};
// calculate the height or width value according to the original image's aspect ratio
var getSizeByRatio = function (ratio, width, height) {
    var res = {};
    if (!width && height) {
        res.width = getFixSize(height * ratio);
    }
    else if (width) {
        res.height = getFixSize(width / ratio);
    }
    return res;
};
// According to the `allowDomains`, If it does not meet the requirements, the upload operation needs to be triggered
var checkDomain = function (src, config) {
    var allowDomains = config.allowDomains;
    if (typeof allowDomains === 'function')
        return allowDomains(src);
    return (allowDomains || [/./]).some(function (domain) {
        if (typeof domain === 'string')
            return src.includes(domain);
        return domain.test(src);
    });
};
// image file to be display needs converted to ObjectURL, here it is reversed, for uploading
var transformBlobFromObjectURL = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.onload = function (e) {
                        if (xhr.status === 200)
                            resolve(xhr.response);
                        else
                            reject();
                    };
                    xhr.onerror = function (e) { return reject(e); };
                    xhr.send();
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
// deal with the lack of width and height of the paste, obtain the original image's aspect ratio and then calculate
var correctSize = function (attrs) {
    var src = attrs.src, width = attrs.width, height = attrs.height;
    if (width && height)
        return { width: width, height: height };
    return new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, naturalWidth, naturalHeight, ratio, res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getImageSize(src)];
                case 1:
                    _a = _b.sent(), naturalWidth = _a.naturalWidth, naturalHeight = _a.naturalHeight, ratio = _a.ratio;
                    if (!naturalWidth || !naturalHeight || (!width && !height))
                        return [2 /*return*/, resolve({})];
                    res = getSizeByRatio(ratio, width, height);
                    resolve(res);
                    return [2 /*return*/];
            }
        });
    }); });
};
// keep the aspect ratio after uploading
var constructAttrs = function (oAttrs, nAttrs) { return __awaiter(void 0, void 0, void 0, function () {
    var ratio, ratio;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (nAttrs.width && nAttrs.height)
                    return [2 /*return*/, nAttrs];
                if (!(!nAttrs.width || !nAttrs.height)) return [3 /*break*/, 2];
                return [4 /*yield*/, getImageSize(nAttrs.src)];
            case 1:
                ratio = (_a.sent()).ratio;
                return [2 /*return*/, ratio ? __assign(__assign({}, nAttrs), getSizeByRatio(ratio, nAttrs.width, nAttrs.height)) : nAttrs];
            case 2:
                // nAttrs do not provide width and height
                if (oAttrs.width && oAttrs.height)
                    return [2 /*return*/, nAttrs];
                if (!(!oAttrs.width || !oAttrs.height)) return [3 /*break*/, 4];
                return [4 /*yield*/, getImageSize(nAttrs.src)];
            case 3:
                ratio = (_a.sent()).ratio;
                return [2 /*return*/, ratio ? __assign(__assign({}, nAttrs), getSizeByRatio(ratio, oAttrs.width, oAttrs.height)) : nAttrs];
            case 4: return [2 /*return*/, {}];
        }
    });
}); };
export { checkDomain, constructAttrs, correctSize, getImageFileList, getImageSize, getInputImageFiles, getSizeByRatio, transformBlobFromObjectURL, };
//# sourceMappingURL=utils.js.map